import { Dialog, DialogContent, Typography, Box, Button, TextField } from '@mui/material';
import { useState } from 'react';
import { IoIosInformationCircleOutline } from 'react-icons/io';

interface Props {
  open: boolean;
  agentName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteAgentModal({ open, agentName, onClose, onConfirm }: Props) {
  const [value, setValue] = useState('');

  const isMatch = value.trim() === agentName;

  const handleClose = () => {
    setValue('');
    onClose();
  };

  const handleConfirm = () => {
    if (!isMatch) return;
    onConfirm();
    setValue('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <IoIosInformationCircleOutline size={42} color='#DA0808' />

        <Typography variant='h5' fontWeight={600} mt={1}>
          Are you sure?
        </Typography>

        <Typography variant='body2' color='text.secondary' mt={1.5}>
          Do you really want to delete the agent <b>"{agentName}"</b>? <br /> This action is permanent and cannot be
          undone.
        </Typography>

        <TextField
          fullWidth
          placeholder='Type Agent Name to Confirm'
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={{ mt: 3 }}
        />

        <Box display='flex' gap={2} justifyContent='end' mt={3}>
          <Button
            sx={{
              borderColor: '#ECECEC',
              minWidth: '32px',
              color: '#777777',
              '&:hover': {
                borderColor: '#ECECEC',
                backgroundColor: 'transparent',
                color: '#777777'
              }
            }}
            variant='outlined'
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            variant='contained'
            color='error'
            disabled={!isMatch}
            onClick={handleConfirm}
            sx={{ minWidth: '32px' }}
          >
            Delete
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
